module.exports = __webpack_public_path__ + "static/media/Residential_68.77773af0.jpg";